module.exports = __webpack_public_path__ + "static/media/qrInVendingMachine.db5c9166.png";